export default __webpack_public_path__ + "static/testi-2-80e8e4dd6ce7491265c329a8bb72d727.png";